import WealthWithLeeLogo from '@/assets/branding/wealthwithlee/wealthwithlee-logo.png';

export default {
  name: 'Wealth With Lee',
  isSAML: true,
  allowPersonalCourses: false,
  logo: WealthWithLeeLogo,
  colors: {
    // Brand colors
    brand_primary: '#5DB858',
    brand_primary_hover: '#4E924B', // −10 L, −8 S
    brand_primary_highlight: '#A9DFA6', // +23 L, +7 S
    brand_primary_mid: '#77C673', // +8 L,  +2 S
    brand_primary_dark: '#30632D', // −25 L, −3 S
    brand_secondary: '#477C48', // hue +4°, −15 L, −13 S
  },
};
